import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    item: {
      height: '100%',
    },
  }
})
